// Local (anonymous) history + streak storage
const KEY = "tr_history";
const STREAK_KEY = "tr_streak";

export function saveLocalSession(result) {
  try {
    const list = getLocalHistory();
    list.unshift({
      session_id: result.session_id,
      test_type: result.test_type,
      average_ms: result.average_ms,
      best_ms: result.best_ms,
      median_ms: result.median_ms,
      consistency: result.consistency,
      performance_score: result.performance_score,
      created_at: new Date().toISOString(),
    });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100)));
    updateLocalStreak();
  } catch (e) {}
}

export function getLocalHistory() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function getLocalBest() {
  const list = getLocalHistory();
  if (!list.length) return null;
  return Math.min(...list.map((x) => x.best_ms));
}

function updateLocalStreak() {
  const today = new Date().toISOString().slice(0, 10);
  let data = { last: null, streak: 0 };
  try {
    data = JSON.parse(localStorage.getItem(STREAK_KEY) || "{}");
  } catch {}
  if (data.last === today) return;
  const yest = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
  data.streak = data.last === yest ? (data.streak || 0) + 1 : 1;
  data.last = today;
  localStorage.setItem(STREAK_KEY, JSON.stringify(data));
}

export function getLocalStreak() {
  try {
    return JSON.parse(localStorage.getItem(STREAK_KEY) || "{}").streak || 0;
  } catch {
    return 0;
  }
}
